import { render, staticRenderFns } from "./app-search.vue?vue&type=template&id=0a7123f4&scoped=true&"
import script from "./app-search.vue?vue&type=script&lang=js&"
export * from "./app-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7123f4",
  null
  
)

export default component.exports